import { AppRoute } from 'app/app-layout/constants/app-route.enum';
import { BrowserService } from 'app/core/browser/services/browser.service';
import { take } from 'rxjs/operators';

import { AuthService } from './authentication/services';
import { RouterRequest } from './browser/models';

export function appStartupFactory(authService: AuthService, browserService: BrowserService):
  (authService: AuthService, browserService: BrowserService) => Promise<void> {
  return (): Promise<void> => new Promise((resolve: Function): void => {
    authService.loadJwt()
      .pipe(
        take(1),
      )
      .subscribe((jwt: string) => {
        if (typeof jwt === 'undefined') {
          const navRequest: RouterRequest = new RouterRequest({ route: AppRoute.login });
          browserService.to(navRequest);
        } else {
          return resolve();
        }
      });
  });
}
